<div
	class="container"
	actionCenterLinkEntities
	[activeConfigAndClass]="{ activeConfig: activeConfig(), containerClass: true }"
>
	@if (!activeConfig()) {
		<div class="content main-action-menu nice-scroll overflow">
			@if (implemented) {
				<div class="search-bar">
					<search-bar [placeholderText]="'Type a command or search'" />
				</div>
			}
			@for (option of configs; track option; let i = $index) {
				<div class="action-row">
					<div
						(click)="selectAction(option)"
						class="cursor-pointer actions {{ option.name }}"
						[ngClass]="i === index() ? 'active' : 'inactive'"
					>
						<span
							><mat-icon class="{{ option.name }}" svgIcon="{{ option.icon }}">
							</mat-icon>
							<span class="action-title">{{ option.title | translate }}</span></span
						>
						@if (!!option.hotKey?.icon) {
							<div class="key-list">
								@for (key of option.hotKey.icon; track key) {
									<mat-icon class="key-icon {{ key }}" svgIcon="{{ key }}" />
								}
							</div>
						}
					</div>
				</div>
			}
		</div>
	}

	@if (activeConfig()) {
		<div class="content">
			<div
				class="action-selection-wrapper nice-scroll colored-scroll-track"
				actionCenterLinkEntities
				[activeConfigAndClass]="{ activeConfig: activeConfig(), containerClass: false }"
			>
				<action-center-overlay [config]="activeConfig()" />
			</div>
		</div>
	}
	<action-center-footer
		[activeConfig]="activeConfig()"
		(applyAction)="applyAction()"
		(closeDialog)="closeDialog()"
	></action-center-footer>
</div>
